export default __webpack_public_path__ + "static/media/JindalBG.f713893a.webp";